/**
 * URL base de la API del backend.
 *
 * - REACT_APP_API_URL: fija la URL (build o .env.local).
 * - Túnel Cloudflare/ngrok (HTTPS sin :5000): misma origen /api + setupProxy en dev.
 * - Red local (ej. :3000): mismo host con puerto API (REACT_APP_API_PORT o 5000).
 */
function isTunnelOrPublicHttps(hostname: string, port: string, protocol: string): boolean {
  if (/trycloudflare\.com|ngrok-free\.app|ngrok\.io|loca\.lt|cloudflare/i.test(hostname)) {
    return true;
  }
  if (protocol === 'https:' && (!port || port === '443')) return true;
  return false;
}

function getApiUrl(): string {
  const env = process.env.REACT_APP_API_URL;
  if (env && env.trim()) {
    const base = env.replace(/\/+$/, '');
    return base.endsWith('/api') ? base : `${base}/api`;
  }

  if (typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;
    // Puerto 3001 = gateway producción (scripts/serve-prod-tunnel.cjs) con /api en el mismo origen
    if (port === '3001' || isTunnelOrPublicHttps(hostname, port, protocol)) {
      return `${window.location.origin}/api`;
    }
    const apiPort = (process.env.REACT_APP_API_PORT || '5000').replace(/^:/, '');
    return `${protocol}//${hostname}:${apiPort}/api`;
  }

  return 'http://localhost:5000/api';
}

function getBaseUrl(): string {
  const api = getApiUrl();
  if (api.startsWith('http://') || api.startsWith('https://')) {
    return api.replace(/\/api\/?$/, '') || api.slice(0, -4);
  }
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return 'http://localhost:5000';
}

export const API_URL = getApiUrl();
export const BASE_URL = getBaseUrl();

/** Texto para diagnóstico (pantalla de licencia, errores de red). */
export function getApiUrlDisplay(): string {
  return API_URL.startsWith('http') ? API_URL : `${typeof window !== 'undefined' ? window.location.origin : ''}${API_URL}`;
}
